import { render } from "./PrivacySetsModal.vue?vue&type=template&id=36186d86&lang=pug"
import script from "./PrivacySetsModal.vue?vue&type=script&lang=js"
export * from "./PrivacySetsModal.vue?vue&type=script&lang=js"

import "./PrivacySetsModal.vue?vue&type=style&index=0&id=36186d86&lang=css"

import exportComponent from "/var/jenkins_home/jobs/ohm-landing/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__